import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Trash2 } from 'lucide-react';
import { AdminPagination } from './AdminPagination';
import { formatDateFor } from './adminUtils';

export const AdminUsersTab = ({ users, page, setPage, pageSize, onUpdateRole, onDeleteUser, language }) => {
  const tr = language === 'tr';
  const formatDate = formatDateFor(language);
  return (
    <Card className="bg-slate-900/50 border-slate-800" data-testid="admin-users-tab">
      <CardHeader>
        <CardTitle className="text-white">{tr ? 'Üye Listesi' : 'User List'}</CardTitle>
        <CardDescription className="text-slate-400">
          {tr ? `Toplam ${users.total} üye` : `Total ${users.total} users`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-slate-700">
              <TableHead className="text-slate-400">Email</TableHead>
              <TableHead className="text-slate-400">{tr ? 'İsim' : 'Name'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Rol' : 'Role'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Şirket' : 'Companies'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Değ.' : 'Assess.'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'Kayıt' : 'Registered'}</TableHead>
              <TableHead className="text-slate-400">{tr ? 'İşlem' : 'Action'}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.users.map((u) => (
              <TableRow key={u.id} className="border-slate-700">
                <TableCell className="text-white text-sm">{u.email}</TableCell>
                <TableCell className="text-slate-300 text-sm">{u.full_name || 'N/A'}</TableCell>
                <TableCell>
                  <Select value={u.role} onValueChange={(value) => onUpdateRole(u.id, value)} disabled={u.role === 'admin'}>
                    <SelectTrigger className="w-28 bg-slate-800 border-slate-700 text-white text-xs h-8" data-testid={`user-role-select-${u.id}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-slate-800 border-slate-700">
                      <SelectItem value="user" className="text-white text-xs">User</SelectItem>
                      <SelectItem value="tenant_admin" className="text-white text-xs">Tenant Admin</SelectItem>
                      <SelectItem value="admin" className="text-white text-xs">Admin</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
                <TableCell className="text-slate-300 text-sm">{u.company_count}</TableCell>
                <TableCell className="text-slate-300 text-sm">{u.completed_count}/{u.assessment_count}</TableCell>
                <TableCell className="text-slate-400 text-xs">{formatDate(u.created_at)}</TableCell>
                <TableCell>
                  {u.role !== 'admin' && (
                    <Button variant="ghost" size="sm" onClick={() => onDeleteUser(u.id)} data-testid={`user-delete-btn-${u.id}`}
                      className="text-red-400 hover:text-red-300 hover:bg-red-500/10 h-8 w-8 p-0">
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <AdminPagination page={page} setPage={setPage} total={users.total} pageSize={pageSize} testId="users-pagination" />
      </CardContent>
    </Card>
  );
};
